
import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useComments } from "./CommentsContext";

interface ReplyDialogProps {
  pinId: string;
}

export function ReplyDialog({ pinId }: ReplyDialogProps) {
  const [replyComment, setReplyComment] = useState("");
  const { replyTo, setReplyTo, handleSubmitReply, isSubmitting } = useComments();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handleSubmitReply(pinId, replyComment);
    setReplyComment("");
  };

  return (
    <Dialog open={!!replyTo} onOpenChange={() => setReplyTo(null)}>
      <DialogContent className="sm:max-w-[425px]">
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-medium">
              Responder para @{replyTo?.username}
            </h3>
            <p className="text-sm text-muted-foreground">
              Digite sua resposta abaixo
            </p>
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <Input
              value={replyComment}
              onChange={(e) => setReplyComment(e.target.value)}
              placeholder="Digite sua resposta..."
              disabled={isSubmitting}
            />
            <div className="flex justify-end gap-2">
              <Button
                type="button"
                variant="outline"
                onClick={() => setReplyTo(null)}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                disabled={!replyComment.trim() || isSubmitting}
              >
                Enviar
              </Button>
            </div>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
}
